// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2VG99","name":"ConsentHeader_name__18MuQ","birthday":"ConsentHeader_birthday__1qUYP","skeleton":"ConsentHeader_skeleton__1jBCm"};